<template lang="html">
  <div class="component-wrapper">
    <h2 class="text-center">Üdvözöljük {{customer_name}}!</h2>
    <br>
    <v-row>
    <v-col cols="12" md="6">
    <v-card
      class="mx-auto"
      max-width="344"
      outlined
      shaped
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">
            Személyes adatok
          </v-list-item-title>
        </v-list-item-content>
        <v-icon
          x-large
          dark
          color="orange darken-2"
        >
          perm_contact_calendar
        </v-icon>
      </v-list-item>

      <v-card-text>
        Ahhoz, hogy jelentkezni tudjon képzéseinkre, elsőként a szükséges személyes adatait kell rögzítenie.
      </v-card-text>

      <v-card-actions>
        <v-btn
          outlined
          rounded
          color="primary"
          to="/adatok"
        >
          Adatok rögzítése
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-col>

    <v-col cols="12" md="6">
    <v-card
      class="mx-auto"
      max-width="344"
      outlined
      shaped
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">
            Kategóriák
          </v-list-item-title>
        </v-list-item-content>
        <v-icon
          x-large
          dark
          color="orange darken-2"
        >
          bike_scooter
        </v-icon>
      </v-list-item>

      <v-card-text>
        Ebben a menüpontban jelentkezhet a megszerezni kívánt vezetői engedély kategóriára.
      </v-card-text>

      <v-card-actions>
        <v-btn
          outlined
          rounded
          color="primary"
          to="/kategoriak"
        >
          Szerződés létrehozása
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-col>
    </v-row>

    <v-row>
    <v-col cols="12" md="6">
    <v-card
      class="mx-auto"
      max-width="344"
      outlined
      shaped
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">
            Tanfolyamok
          </v-list-item-title>
        </v-list-item-content>
        <v-icon
          x-large
          dark
          color="orange darken-2"
        >
          school
        </v-icon>
      </v-list-item>

      <v-card-text>
        Szerződés létrehozását követően itt választhat a meghirdetett tantermi képzések közül.
      </v-card-text>

      <v-card-actions>
        <v-btn
          outlined
          rounded
          color="primary"
          to="/tanfolyamok"
        >
          Jelentkezés
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-col>

    <v-col cols="12" md="6">
    <v-card
      class="mx-auto"
      max-width="344"
      outlined
      shaped
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">
            Vizsgák
          </v-list-item-title>
        </v-list-item-content>
        <v-icon
          x-large
          dark
          color="orange darken-2"
        >
          date_range
        </v-icon>
      </v-list-item>

      <v-card-text>
        Amennyiben már jelentkezett vizsgára, annak időpontját, később pedig eredményeit itt tekintheti meg.
      </v-card-text>

      <v-card-actions>
        <v-btn
          outlined
          rounded
          color="primary"
          to="/vizsgak"
        >
          Eredmények megtekintése
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-col>
    </v-row>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'

  export default {
    data () {
      return {
      }
    },
    mounted() {

    },
    computed: {
    ...mapFields([
    'ids.customer_name',
  ]),
  },
  }
</script>

<style lang="css">
</style>
